import {SystemEntity, ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import https from 'https';
import http from 'http';
import moment from 'moment';
// @ts-ignore
import * as request from 'request';
import {Observable, Observer} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import fs from 'fs';
import {v4 as uuid} from 'uuid';

@HookClass('http')
export class HttpHook extends BaseHook {

    @Hook('73466be1-da61-4a4c-ae5f-1099ef021b85')
    public get(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: {}
        };

        return this.system.pipe(concatMap((system: SystemEntity) => {
            options.headers['nick-system'] = system.id;
            options.headers['authorization'] = this.token;

            return this._get(options, inputArtifact);
        }));
    }

    @Hook('a575d026-2d3d-4cd8-aac3-9fbea1e4c45b')
    public postExternal(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: inputArtifact.object.config.headers ? inputArtifact.object.config.headers : {}
        };

        options.url = this.buildRoute(inputArtifact.object.config.url, inputArtifact.object.config.params);
        options.headers = this.buildAuthorization(inputArtifact.object.config.headers);
        options.rejectUnauthorized = inputArtifact.object.config?.rejectUnauthorized;
        options.requestCert = inputArtifact.object.config?.requestCert;

        if (options.headers && options.headers['Content-Type'] == 'x-www-form-urlencoded') {
            options.form = inputArtifact.object.config.body;
            options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            options.method = 'POST';
        } else if (options.headers && options.headers['Content-Type'] == 'multipart/form-data') {
            options.formData = inputArtifact.object.config.body;
            options.formData[inputArtifact.object.config.fileKey] = {
                value: fs.createReadStream(inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.path),
                options: {
                    filename: inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.name,
                    contentType: inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.type
                }
            };
            options.method = 'POST';
        } else if (inputArtifact.object.config.body) {
            options.body = inputArtifact.object.config.body;
            options.json = (inputArtifact.object.config && inputArtifact.object.config.hasOwnProperty('json')) ? inputArtifact.object.config.json : true;
        }

        if (inputArtifact.object.config.pfx) {
            options.pfx = inputArtifact.object.config.pfx;
            options.passphrase = inputArtifact.object.config.passphrase;
        }

        if (inputArtifact.object.config.ca) {
            options.ca = inputArtifact.object.config.ca;
            options.passphrase = inputArtifact.object.config.passphrase;
        }

        options.isDownload = inputArtifact.object.config?.isDownload;
        options.gzip = inputArtifact.object.config?.gzip;
        options.timeout = inputArtifact.object.config?.timeout;

        return new Observable((observer: Observer<any>) => {

            if (options.isDownload) {
                options.rejectUnauthorized = false;
                options.method = 'POST';

                const fileName = `/tmp/${uuid()}`;
                const outputArtifact = new NickProcessArtfact();

                request.post(options.url, options)
                    .on('error', (err: any) => {
                        observer.error(err);
                        observer.complete();
                    })
                    .on('end', (err: any) => {
                        outputArtifact.object = fs.createReadStream(fileName);
                        observer.next(outputArtifact);
                        observer.complete();
                    })
                    .pipe(fs.createWriteStream(fileName));

                return;
            }

            request.post(options, ((error: any, response: any, body: any) => {
                if (error) {
                    observer.error(error);
                    observer.complete();
                } else {
                    const outputArtifact = new NickProcessArtfact();

                    if (body instanceof Object) {
                        outputArtifact.object = body;
                    } else {
                        try {
                            const parsed = JSON.parse(body);
                            if (typeof parsed === 'number' && parsed.toString() !== body) {
                                outputArtifact.object = body;
                            } else {
                                outputArtifact.object = parsed;
                            }
                        } catch (e) {
                            outputArtifact.object = body;
                        }
                    }

                    if (inputArtifact.object.config.statusError instanceof Array && inputArtifact.object.config.statusError.indexOf(response.statusCode) >= 0) {
                        outputArtifact.kind = ArtfactKind.ERROR;

                        outputArtifact.object = {
                            message: outputArtifact.object,
                            statusCode: response.statusCode,
                            statusMessage: response.statusMessage
                        };

                        observer.error(outputArtifact);
                    } else {

                        if (response.statusCode >= 200 && response.statusCode <= 409)
                            observer.next(outputArtifact);
                        else {
                            outputArtifact.kind = ArtfactKind.ERROR;
                            observer.error(outputArtifact);
                        }
                    }

                    observer.complete();
                }
            }));
        });
    }

    @Hook('203842d9-28e3-4d6c-b808-5b2d31a17cf4')
    public getExternal(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: inputArtifact.object.config.headers ? inputArtifact.object.config.headers : {}
        };

        options.url = this.buildRoute(inputArtifact.object.config.url, inputArtifact.object.config.params);
        options.headers = this.buildAuthorization(inputArtifact.object.config.headers);
        options.gzip = inputArtifact.object.config?.gzip;
        options.encoding = inputArtifact.object.config?.encoding;
        options.isDownload = inputArtifact.object.config?.isDownload;
        options.rejectUnauthorized = inputArtifact.object.config?.rejectUnauthorized;
        options.requestCert = inputArtifact.object.config?.requestCert;

        return this._get(options, inputArtifact);
    }

    @Hook('ebc78ebf-2523-4777-b4f0-e6112cd9e5a2')
    public deleteExternal(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: inputArtifact.object.config.headers ? inputArtifact.object.config.headers : {}
        };

        options.url = this.buildRoute(inputArtifact.object.config.url, inputArtifact.object.config.params);
        options.headers = this.buildAuthorization(inputArtifact.object.config.headers);
        options.gzip = inputArtifact.object.config?.gzip;
        options.encoding = inputArtifact.object.config?.encoding;
        options.rejectUnauthorized = inputArtifact.object.config?.rejectUnauthorized;
        options.requestCert = inputArtifact.object.config?.requestCert;

        return new Observable((observer: Observer<any>) => {
            request.delete(options, ((error: any, response: any, body: any) => {
                if (error) {
                    observer.error(error);
                    observer.complete();
                } else {
                    if (body instanceof Object) {
                        inputArtifact.object = body;
                    } else {
                        try {
                            const parsed = JSON.parse(body);
                            if (typeof parsed === 'number' && parsed.toString() !== body) {
                                inputArtifact.object = body;
                            } else {
                                inputArtifact.object = parsed;
                            }
                        } catch (e) {
                            inputArtifact.object = body;
                        }
                    }
                    observer.next(inputArtifact);
                    observer.complete();
                }
            }));
        });
    }

    @Hook('85be39b2-788c-48fe-9cea-e96b1753c1c0')
    public patchExternal(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: inputArtifact.object.config.headers ? inputArtifact.object.config.headers : {}
        };

        options.url = this.buildRoute(inputArtifact.object.config.url, inputArtifact.object.config.params);
        options.headers = this.buildAuthorization(inputArtifact.object.config.headers);
        options.rejectUnauthorized = inputArtifact.object.config?.rejectUnauthorized;
        options.requestCert = inputArtifact.object.config?.requestCert;

        if (options.headers && options.headers['Content-Type'] == 'x-www-form-urlencoded') {
            options.form = inputArtifact.object.config.body;
            options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            options.method = 'PATCH'; // Método PATCH
        } else if (inputArtifact.object.config.body) {
            options.body = inputArtifact.object.config.body;
            options.json = true;
            options.method = 'PATCH'; // Método PATCH
        }

        return new Observable((observer: Observer<any>) => {
            request.patch(options, ((error: any, response: any, body: any) => {
                if (error) {
                    observer.error(error);
                    observer.complete();
                } else {
                    if (body instanceof Object) {
                        inputArtifact.object = body;
                    } else {
                        try {
                            const parsed = JSON.parse(body);
                            if (typeof parsed === 'number' && parsed.toString() !== body) {
                                inputArtifact.object = body;
                            } else {
                                inputArtifact.object = parsed;
                            }
                        } catch (e) {
                            inputArtifact.object = body;
                        }
                    }

                    if (response.statusCode >= 200 && response.statusCode <= 409)
                        observer.next(inputArtifact);
                    else {
                        inputArtifact.kind = ArtfactKind.ERROR;
                        observer.error(inputArtifact);
                    }

                    observer.complete();
                }
            }));
        });
    }

    @Hook('f1e75d44-c8ed-4695-aec1-1d41a888316e')
    public putExternal(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const options: any = {
            url: `${inputArtifact.object.config.url}`,
            headers: inputArtifact.object.config.headers ? inputArtifact.object.config.headers : {}
        };

        options.url = this.buildRoute(inputArtifact.object.config.url, inputArtifact.object.config.params);
        options.headers = this.buildAuthorization(inputArtifact.object.config.headers);
        options.rejectUnauthorized = inputArtifact.object.config?.rejectUnauthorized;
        options.requestCert = inputArtifact.object.config?.requestCert;

        if (options.headers && options.headers['Content-Type'] == 'x-www-form-urlencoded') {
            options.form = inputArtifact.object.config.body;
            options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            options.method = 'PUT';

        } else if (options.headers && options.headers['Content-Type'] == 'multipart/form-data') {
            options.formData = inputArtifact.object.config.body;
            options.formData[inputArtifact.object.config.fileKey] = {
                value: fs.createReadStream(inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.path),
                options: {
                    filename: inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.name,
                    contentType: inputArtifact.object.config.body[inputArtifact.object.config.fileKey].File.type
                }
            };
            options.method = 'PUT';

        } else if (inputArtifact.object.config.body) {
            options.body = inputArtifact.object.config.body;
            options.json = true;
        }

        return new Observable((observer: Observer<any>) => {
            request.put(options, ((error: any, response: any, body: any) => {
                if (error) {
                    observer.error(error);
                    observer.complete();
                } else {
                    if (body instanceof Object) {
                        inputArtifact.object = body;
                    } else {
                        try {
                            const parsed = JSON.parse(body);
                            if (typeof parsed === 'number' && parsed.toString() !== body) {
                                inputArtifact.object = body;
                            } else {
                                inputArtifact.object = parsed;
                            }
                        } catch (e) {
                            inputArtifact.object = body;
                        }
                    }

                    // inputArtifact.object.response = {
                    //     status: response.statusCode,
                    //     statusMessage: response.statusMessage,
                    //     headers: response.headers
                    // }

                    if (response.statusCode >= 200 && response.statusCode <= 409)
                        observer.next(inputArtifact);
                    else {
                        inputArtifact.kind = ArtfactKind.ERROR;
                        observer.error(inputArtifact);
                    }

                    observer.complete();
                }
            }));
        });
    }

    private buildAuthorization(headers: any): any {
        if (headers && (headers.hasOwnProperty('Authorization') || headers.hasOwnProperty('authorization'))) {
            const authorization = headers['Authorization'] || headers['authorization'];
            if (authorization && typeof authorization != 'string') {
                switch (authorization.type.toLowerCase()) {
                    case 'basic': {
                        const authHeader = Buffer.from(`${authorization.username}:${authorization.password}`).toString('base64');
                        delete headers['Authorization'];
                        delete headers['authorization'];
                        headers['authorization'] = `Basic ${authHeader}`;
                        break;
                    }
                    case 'bearer': {
                        delete headers['Authorization'];
                        delete headers['authorization'];
                        headers['authorization'] = `Bearer ${authorization.token}`;
                        break;
                    }
                }
            }
        }

        return headers;
    }

    private buildRoute(url: string, params?: any): URL {
        const _url = new URL('https://dummy');

        if (params) {
            Object.keys(params).forEach((key: string) => {
                if (url.indexOf(`{{${key}}}`) > -1) {
                    url = url.replace(`{{${key}}}`, params[key]);
                } else {
                    if (params[key] !== undefined && params[key] != null) {
                        const value = params[key];

                        if (!(value instanceof Array) && value instanceof Object && Object.keys(value).length) {
                            Object.keys(value).forEach((insideKey) => {
                                if (value[insideKey] !== undefined) {
                                    // todo: deal all properties, not only array...

                                    let skipAppend = false;
                                    if (value[insideKey] instanceof Array) {
                                        value[insideKey] = value[insideKey].map((value: any) => {
                                            if (value instanceof Date)
                                                return moment(value).parseZone().format();

                                            if (!isNaN(value))
                                                return value;

                                            if (typeof value === 'string')
                                                return value;

                                            if (value instanceof Object) {
                                                skipAppend = true;
                                                _url.searchParams.append(insideKey, JSON.stringify(value));
                                            }

                                            return value;
                                        });
                                    } else if (value[insideKey] instanceof Object) {
                                        value[insideKey] = JSON.stringify(value[insideKey]);
                                    }

                                    if (!skipAppend)
                                        _url.searchParams.append(insideKey, value[insideKey]);
                                }
                            });
                        } else {
                            _url.searchParams.append(key, params[key]);
                        }
                    }
                }
            });
        }

        const finalUrl = new URL(url);
        _url.searchParams.forEach((value: string, key: string) => finalUrl.searchParams.append(key, value));
        return finalUrl;
    }

    private _get(options: any, inputArtifact: any) {

        if (options.isDownload) {
            options.rejectUnauthorized = false;
        }

        return new Observable((observer: Observer<any>) => {
            if (options.isDownload) {
                const _protocol = options.url.toString().startsWith('https') ? https : http;
                _protocol.get(options.url, options, (response: any) => {
                    const chunks: any[] = [];

                    response.on('data', (chunk: any) => {
                        chunks.push(chunk);
                    });

                    response.on('end', () => {
                        inputArtifact.object = Buffer.concat(chunks);
                        observer.next(inputArtifact);
                        observer.complete();
                    });
                });
            } else {
                request.get(options, ((error: any, response: any, body: any) => {
                    if (error) {
                        observer.error(error);
                        observer.complete();
                    } else {
                        if (body instanceof Object) {
                            inputArtifact.object = body;
                        } else {
                            try {
                                const parsed = JSON.parse(body);
                                if (typeof parsed === 'number' && parsed.toString() !== body) {
                                    inputArtifact.object = body;
                                } else {
                                    inputArtifact.object = parsed;
                                }
                            } catch (e) {
                                inputArtifact.object = body;
                            }
                        }
                        observer.next(inputArtifact);
                        observer.complete();
                    }
                }));
            }
        });
    }
}
